import axios from 'axios'

export default class Provider {
  constructor (settings) {
    this.settings = { ...settings }
  }

  createConfig (url, params, requestType) {
    return Object.assign({
      url,
      params: { ...params },
      headers: {
        'Content-Type': (requestType === 'get')
          ? 'application/json'
          : 'multipart/form-data'
      }
    }, this.settings)
  }

  getJSON (service, params) {
    const config = this.createConfig(service, params, 'get')
    return new Promise((resolve, reject) => {
      return axios(config)
        .then((response) => {
          resolve(response.data)
        })
        .catch(error => {
          throw new Error(`Api Service GET ${service} Failed: ${error}`)
        })
    })
  }

  postJSON (service, params) {
    const config = this.createConfig(service, params, 'post')
    return new Promise((resolve, reject) => {
      return axios(config)
        .then((response) => {
          resolve(response.data)
        })
        .catch(error => {
          throw new Error(`Api Service POST ${service} Failed: ${error}`)
        })
    })
  }
}
